import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import SideBar from "../../SideBar";
import Swal from "sweetalert2";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { FaArrowLeft } from "react-icons/fa";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
`;

const Center = styled.div`
  flex: 1;
  display: inline;
  text-align: center;
`;

const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  margin-top: 20px;
`;

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`;
const Div = styled.div``;
const Label = styled.label``;
const Input = styled.input`
  width: 100%;
`;
const Span = styled.span`
  color: red;
`;
const Textarea = styled.textarea``;

const Select = styled.select`
  padding: 5px 7px;
  border-radius: 5px;
`;
const Option = styled.option``;

const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;
const scroll = {
  width: "650px",
  overflowX: "scroll",
};
const Create = () => {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  // const url = "http://192.168.1.15:4000/api/";
  const navigate = useNavigate()
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const Id = useLocation().pathname.split("/")[2];
  const Name = localStorage.getItem("Name");

  const [expDate, setExpDate] = useState("");
  const [alertDate, setAlertDate] = useState("");
  const [medicineList, setMedicineList] = useState([]);
  const [isItem, setIsItem] = useState(false);

  const [isAccItem, setIsAccItem] = useState(false);
  const [isGenItem, setIsGenItem] = useState(false);
  const [isMedItem, setIsMedItem] = useState(false);
  const [medTran, setMedTran] = useState("");

  const [upProData, setUpProData] = useState([]);
  const [upMedData, setUpMedData] = useState([]);
  const [upProAcc, setUpProAcc] = useState([]);
  const [upGen, setUpGen] = useState([]);
  const [seq, setSeq] = useState("");
  const [upBranchID, setUpBranchID] = useState("");
  const [upBranchName, setUpBranchName] = useState("");

  const [branchID, setBranchID] = useState("");
  const [branchLists, setBranchLists] = useState([]);

  const [date, setDate] = useState("");
  const [name, setName] = useState("");

  const [stockReqData, setStockReqData] = useState([])

  const StockReqID = useLocation().pathname.split("/")[2];
  const [code, setCode] = useState("");

  // const handleMedErrorInputChange = event => {
  //   console.log(event.split('.')[0], 'pro event')
  // }
  useEffect(() => {
    const getCode = async () => {
      const res = await api.get("stock-transfers/code");
      // console.log(res.data.data, "data seq");
      setCode(res.data.data.patientID);
      setSeq(res.data.data.seq);
      // console.log(res.data.data.patientID, "code");
    };
    const getMedicine = async () => {
      const res = await api.get("medicine-items");
      setMedicineList(res.data.list);
    };

    const getBranch = async () => {
      const res = await api.get("branches");
      // console.log(res.data.list);
      setBranchID(res.data.list[0]._id);
      setBranchLists(res.data.list);
    };

    const getStockReqList = async () => {
      try {
        const res = await api.get("stock-request/" + StockReqID);
        // console.log(res.data.data[0], "Req");
        setStockReqData(res.data.data[0])
        setUpBranchID(res.data.data[0].relatedBranch._id);
        setUpBranchName(res.data.data[0].relatedBranch.name);

        //NOTE For Medicine
        if (
          res.data.data[0].medicineLists !== null &&
          res.data.data[0].medicineLists.length > 0
        ) {
          const newData = res.data.data[0].medicineLists.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.medicineItemName : "",
              item_id: data.item_id,
              stockQty: data.HOCurrentQuantity,
              requestedQty: data.requestedQty,
              purchasePrice: data.purchasePrice,
              relatedBatch: data.relatedBatch,
              relatedItemUnit: data.relatedItemUnit

            };
          });
          setUpMedData(newData);
          // console.log(newData, "dat");
          // console.log(newData.map(i => i.stockQty)[0] === 0, 'w')

          setIsMedItem(true);
        }

      } catch (err) { }
    };

    getStockReqList();
    getMedicine();
    getBranch();
    getCode();
  }, []);


  const handleMedInputChange = (event, id, field) => {
    const value = event.target.value;

    const newData = upMedData.map((data) => {
      if (data.id === id) {
        const updatedData = {
          ...data,
          [field]: value, // dynamic field update
        };

        // Additional computed fields
        if (field === "transferQty") {
          updatedData.totalPrice =
            parseInt(value) * parseInt(data.purchasePrice || 0) || 0;
          updatedData.transferQty =
            data.HOCurrentQuantity === 0 ? 0 : parseInt(value) || 0;

        } else if (["expiredDate", "alertDate"].includes(field)) {
          updatedData.expiredDate = value;
          updatedData.alertDate = value;

        }

        return updatedData;
      }
      return data;
    });

    // Optionally update something based on new value
    setMedTran(parseInt(value) || 0);
    setUpMedData([...newData]);
  };


  //NOTE to delete proecedure medicine
  const removeMedicine = (index) => {
    setUpMedData(upMedData.filter((el, ind) => ind !== index));
  };

  //End Medicine add row


  const submit = (id) => {
    confirmAlert({
      title: "Transfer Create?",
      message: "Are you fill TransferQty = 0 <or> Greater than RequestQty?",
      buttons: [
        {
          label: "Yes",
          onClick: () => create(),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const create = () => {


    const data = {
      date: date,
      stockRequestID: StockReqID,
      // relatedBranch: branchID,
      requestNo: code,
      requestedBy: Name,
      transferNo: stockReqData.requestNo,
      transferBy: stockReqData.requestedBy,
      medicineLists: upMedData,

      status: true,
      seq: seq,
      relatedBranch: upBranchID
    };

    // alert(JSON.stringify(data));
    // if (upBranchID) {
    //   data.relatedBranch = upBranchID;
    // }

    api
      .post("stock-transfer", data)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "Successfully Created",
          icon: "success",
          showConfirmButton: false,
          timer: 2000

        });
        navigate("/stock-req")
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          showConfirmButton: false,
          timer: 2000
        });
        console.log(err, 'err')
      });

  };

  const medCheck = medTran > upMedData[0] ? upMedData[0].requestedQty : "";
  // console.log(upMedData, 'upMedData')
  return (
    <div classNameName='App'>
      <div className='wrapper'>
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <Link to='/stock-req'>
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className='breadcrumb-item active'>
                      Stock Transfer Create
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div className='card-body row border border-dark'>
                <h5>Create</h5>
                <div className='ml-5 col-8 py-5'>
                  <div className='row'>
                    <div className='col-6 form-group '>
                      <Label>
                        Date<Span>*</Span>
                      </Label>
                      <Input
                        type='date'
                        className='form-control'
                        onChange={(e) => setDate(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>

                    <div className='col-md-6 mt-1'>
                      <div class='form-group'>
                        <label for='name'>Branches</label>
                        <select
                          class='custom-select border-info'
                          name='account_type_id'
                          id='cat'
                          style={{ borderRadius: "15px" }}

                        >
                          <option value={upBranchID}>{upBranchName}</option>

                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-6 form-group '>
                      <Label>
                        Request No:<Span>*</Span>
                      </Label>
                      <Input
                        type='text'
                        className='form-control'
                        disabled
                        value={stockReqData?.requestNo}
                        // onChange={(e) => setCode(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                    <div className='col-6 form-group'>
                      <Label>
                        Request By:<Span>*</Span>
                      </Label>
                      <Input
                        type='text'
                        className='form-control'
                        disabled
                        value={stockReqData?.requestedBy}
                        // onChange={(e) => setName(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-6 form-group '>
                      <Label>
                        Transfer No:<Span>*</Span>
                      </Label>
                      <Input
                        type='text'
                        className='form-control'
                        value={code}

                        onChange={(e) => setCode(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                    <div className='col-6 form-group'>
                      <Label>
                        Issued By:<Span>*</Span>
                      </Label>
                      <Input
                        type='text'
                        className='form-control'
                        value={Name}
                        onChange={(e) => setName(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12 mt-3' style={scroll}>
                      <h5>Items</h5>

                      <Table className='table table-striped'>
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th style={{ width: "200px" }}>Item Name</Th>

                            <Th style={{ width: "200px" }}>HO Stock Qty</Th>

                            <Th>Req Qty</Th>
                            <Th >Purchase Price</Th>
                            <Th>Transfer Qty</Th>
                            <Th>Total</Th>
                            <Th>Unit</Th>
                            <Th>Expired Date</Th>
                            <Th>Alert Date</Th>
                          </Tr>
                        </Thead>
                        {isMedItem && (
                          <Tbody>
                            {upMedData &&
                              upMedData.map((item, index) => (
                                <Tr>
                                  <Td>{++index}</Td>
                                  {item?.stockQty === 0 ? (
                                    <Td>
                                      <b className='text-red'>{item.name}</b>
                                    </Td>
                                  ) : (
                                    <Td>{item.name}</Td>
                                  )}
                                  {item?.stockQty === 0 ? (
                                    <Td>
                                      <b className='text-red'>
                                        {item.stockQty}
                                      </b>
                                    </Td>
                                  ) : (
                                    <Td>{item?.stockQty || 0}</Td>
                                  )}
                                  {/* <Td>{procedure.purchasePrice}</Td> */}
                                  <Td>{item.requestedQty}</Td>
                                  <Td>{item.purchasePrice || 0}</Td>
                                  <Td>
                                    {/* {console.log(item.transferQty, 'tran qty')} */}
                                    {item.transferQty > item.requestedQty ||
                                      item?.stockQty === 0 || item?.stockQty < item.transferQty ? (
                                      <>
                                        <input
                                          type='number'
                                          defaultValue={item.transferQty}
                                          style={{
                                            borderRadius: "10px",
                                            border: "2px solid red",
                                            width: "150px",
                                          }}
                                          className='text-center form-control'
                                          onChange={(event) =>
                                            handleMedInputChange(
                                              event,
                                              item.id,
                                              "transferQty"
                                            )
                                          }
                                        />
                                        {item?.stockQty === 0 ? (
                                          <p style={{ color: "red" }}>
                                            Reorder items or Fill only '0'
                                          </p>
                                        ) : item?.stockQty < item.transferQty && (
                                          <p style={{ color: "red" }}>
                                            Transfer Qty must have less than
                                            Stock Qty!
                                          </p>
                                        )
                                        }
                                      </>
                                    ) : (
                                      <input
                                        type='number'
                                        defaultValue={item.transferQty}
                                        style={{
                                          borderRadius: "10px",
                                          width: "150px",
                                        }}
                                        className='text-center form-control'
                                        onChange={(event) =>
                                          handleMedInputChange(
                                            event,
                                            item.id,
                                            "transferQty"
                                          )
                                        }
                                      />
                                    )}
                                    {/* <input
                                      type='number'
                                      defaultValue={item.transferQty}
                                      style={{ borderRadius: '10px' }}
                                      className='text-center'
                                      onChange={event =>
                                        handleMedInputChange(
                                          event,
                                          item.id,
                                          'transferQty'
                                        )
                                      }
                                      className='text-center'
                                    /> */}
                                  </Td>
                                  <Td>
                                    <input
                                      type='number'
                                      value={
                                        item?.transferQty *
                                        item?.purchasePrice
                                      }
                                      style={{
                                        borderRadius: "10px",
                                        width: "150px",
                                      }}
                                      className='text-center form-control'
                                      disabled
                                    />
                                  </Td>
                                  <Td>{item.relatedItemUnit?.unitName}</Td>
                                  <Td>
                                    <input
                                      type='date'
                                      style={{ borderRadius: "10px" }}
                                      className='text-center form-control'
                                      onChange={(event) =>
                                        handleMedInputChange(
                                          event,
                                          item.id,
                                          "expDate"
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td>
                                    <input
                                      type='date'
                                      style={{ borderRadius: "10px" }}
                                      className='text-center form-control'
                                      onChange={(event) =>
                                        handleMedInputChange(
                                          event,
                                          item.id,
                                          "alertDate"
                                        )
                                      }
                                    />
                                  </Td>

                                </Tr>
                              ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>


                    {/* NOTE End Procedure Accessory */}
                  </div>
                </div>
                <Top>
                  <div className='row' style={{ marginLeft: "330px" }}>
                    {/* {console.log(upProData[0].requestedQty, 'pro tran cr btn')} */}

                    <div className=' col-md-4'>
                      {upMedData.map((i) => i.item_id.currentQuantity === 0)
                        ? (
                          <Button
                            className='btn btn-sm btn-primary'
                            style={{
                              color: "white",
                            }}
                            onClick={submit}
                          // disabled
                          >
                            Submit
                          </Button>
                        ) : medTran ? (
                          medTran >
                            (upMedData[0] ? upMedData[0].requestedQty : "") ? (
                            <Button
                              className='btn btn-sm btn-success'
                              onClick={create}
                              disabled
                            >
                              Submit
                            </Button>
                          ) : (
                            <Button
                              className='btn btn-sm btn-success'
                              style={{
                                color: "black",
                              }}
                              onClick={create}
                            >
                              Submit
                            </Button>
                          )
                        ) : (
                          <Button
                            className='btn btn-sm btn-success'
                            style={{ color: "black" }}
                            onClick={create}
                          >
                            Submit
                          </Button>
                        )}
                    </div>

                    {/* <div className='col-md-6'>
                      
                        <Button
                         className='btn btn-sm btn-success'
                          style={{  color: 'black' }}
                          onClick={create}
                        >
                          Submit
                        </Button>
                      </div> */}

                    <div className='ml-3 col-md-4'>
                      <Link
                        to='stock-req'
                        className='btn btn-sm px-3 py-1 text-white'
                        style={{
                          borderRadius: "10px",
                          marginTop: "1.7em",
                          fontSize: "12px",
                          width: "95px",
                          backgroundColor: "black",
                          height: "32px",
                        }}
                      >
                        Cancel
                      </Link>
                    </div>
                    <div className='col-3'>
                      <Link
                        to={"/show-print/" + Id}
                        style={{
                          borderRadius: "13px",
                          marginTop: "1.5em",
                          fontSize: "13px",
                          backgroundColor: "black",

                          width: "80px",
                        }}
                        className='btn btn-sm mb-2 text-white'
                      >
                        Print
                      </Link>
                    </div>
                  </div>
                </Top>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer' style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};

export default Create;
